import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Handshake } from "lucide-react";
import { api } from "@/lib/api";
import { formatIsoDay, formatMoney } from "@/lib/format";
import { PromiseBadge } from "@/lib/finance";

// Sipariş detayı: bu satışa bağlı açık ödeme sözleri (tarih / tutar / durum)
export default function OrderPromises({ orderId, reload }) {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/odeme-sozleri", { params: { order_id: orderId, status: "bekliyor,kismen,gecikti" } }).then(({ data }) => setItems(data.items)).catch(() => setItems([])); }, [orderId, reload]);
  if (!items.length) return null;
  return (
    <div className="panel p-3 border-amber-200 bg-amber-50/50 flex flex-wrap items-center gap-x-5 gap-y-1 text-[13px]" data-testid="order-promises">
      <span className="flex items-center gap-1 font-semibold text-amber-900"><Handshake className="h-4 w-4" />Ödeme Sözü</span>
      {items.map((p) => (
        <button key={p.id} onClick={() => navigate(`/odeme-sozleri?id=${p.id}`)} className="flex items-center gap-2 hover:underline" data-testid={`order-promise-${p.promise_no}`}>
          <span className="font-mono text-[12px]">{formatIsoDay(p.promise_date)}</span>
          <span className="font-mono font-semibold">{formatMoney(p.amount, p.currency)}</span>
          {p.paid_amount > 0 && <span className="text-[11px] text-slate-500">ödenen {formatMoney(p.paid_amount, p.currency)}</span>}
          <PromiseBadge status={p.status} testid={`order-promise-status-${p.promise_no}`} />
        </button>
      ))}
    </div>
  );
}
